/**
 * Quote Page - Dynamic loading from localStorage
 */

(function() {
  const itemsContainer = document.getElementById('quote-cart-items');
  const emptyState = document.getElementById('quote-cart-empty');
  const summaryContainer = document.getElementById('quote-cart-summary');
  const totalEl = document.getElementById('quote-total');
  const itemsCountEl = document.getElementById('quote-items-count');
  const whatsappBtn = document.getElementById('quote-whatsapp');
  const emailBtn = document.getElementById('quote-email-btn');

  if (!itemsContainer) return;

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function formatPriceWithVAT(cents) {
    return `<span data-vat-original-price-incl="${cents}">${formatPrice(cents)}</span>`;
  }

  async function fetchVariantData(variantId, productHandle) {
    try {
      // Method 1: If we have product handle, fetch directly
      if (productHandle) {
        console.log(`Fetching product by handle: ${productHandle}`);
        const response = await fetch(`/products/${productHandle}.js`);
        if (response.ok) {
          const product = await response.json();
          const variant = product.variants.find(v => v.id.toString() === variantId.toString());
          if (variant) {
            console.log(`Found variant ${variantId} in ${product.title}`);
            return { product, variant };
          }
        }
      }

      // Method 2: Search through all products
      console.log(`Searching for variant ${variantId} in all products`);
      let page = 1;
      const limit = 250;

      while (page <= 5) { // Max 5 pages = 1250 products
        const response = await fetch(`/products.json?limit=${limit}&page=${page}`);
        if (!response.ok) break;

        const data = await response.json();
        if (data.products.length === 0) break;

        // Search in current batch
        for (const product of data.products) {
          const variant = product.variants.find(v => v.id.toString() === variantId.toString());
          if (variant) {
            console.log(`Found variant ${variantId} in ${product.title}`);
            return { product, variant };
          }
        }

        // If less than limit, we got all products
        if (data.products.length < limit) break;
        page++;
      }

      console.warn(`Variant ${variantId} not found`);
      return null;
    } catch (error) {
      console.error(`Error fetching variant ${variantId}:`, error);
      return null;
    }
  }

  async function loadQuoteItems() {
    if (!window.quoteBasket) {
      console.error('Quote basket not initialized');
      itemsContainer.innerHTML = '<p style="text-align:center;color:#e74c3c;padding:40px">Quote basket not initialized. Please refresh the page.</p>';
      return;
    }

    const quoteItems = window.quoteBasket.getItems();
    console.log('Loading quote items:', quoteItems);

    if (quoteItems.length === 0) {
      itemsContainer.style.display = 'none';
      summaryContainer.style.display = 'none';
      emptyState.style.display = 'block';
      if (itemsCountEl) itemsCountEl.textContent = '0';
      return;
    }

    // Show loading
    itemsContainer.innerHTML = '<p style="text-align:center;color:#666;padding:40px">Loading your items...</p>';
    itemsContainer.style.display = 'block';

    try {
      const validItems = [];
      let totalPrice = 0;

      // Fetch all variants in parallel
      const promises = quoteItems.map(item => fetchVariantData(item.variant_id, item.product_handle));
      const results = await Promise.all(promises);

      // Process results
      quoteItems.forEach((item, index) => {
        const result = results[index];
        if (result && result.variant) {
          const linePrice = result.variant.price * item.quantity;
          totalPrice += linePrice;
          validItems.push({
            product: result.product,
            variant: result.variant,
            quantity: item.quantity,
            linePrice: linePrice
          });
        } else {
          console.warn(`Skipping variant ${item.variant_id} - not found`);
        }
      });

      console.log('Valid items loaded:', validItems.length);

      if (validItems.length === 0) {
        itemsContainer.innerHTML = '<p style="text-align:center;color:#666;padding:40px">No valid items found. The products may have been deleted.</p>';
        summaryContainer.style.display = 'none';
        return;
      }

      emptyState.style.display = 'none';
      itemsContainer.style.display = 'flex';
      summaryContainer.style.display = 'flex';

      if (itemsCountEl) itemsCountEl.textContent = validItems.length;

      itemsContainer.innerHTML = validItems.map((item) => {
        const productUrl = `/products/${item.product.handle}${item.variant.id !== item.product.variants[0].id ? '?variant=' + item.variant.id : ''}`;
        const unitPrice = formatPriceWithVAT(item.variant.price);

        return `
          <div class="quote-cart-item item-row" data-variant-id="${item.variant.id}">
            <div class="ci-thumb">
              <a href="${productUrl}" class="ci-thumb__link">
                ${item.product.featured_image ? `<img src="${item.product.featured_image}" alt="${item.product.title}" loading="lazy">` : ''}
              </a>
            </div>
            <div class="ci-info">
              <div class="ci-name"><a href="${productUrl}">${item.product.title}</a></div>
              ${item.variant.title !== 'Default Title' ? `<div class="ci-variant">${item.variant.title}</div>` : ''}
              <div class="ci-unit-price">${unitPrice} each</div>
            </div>
            <div class="ci-right">
              <div class="ci-line-total">${formatPriceWithVAT(item.linePrice)}</div>
              <div class="ci-stepper">
                <button type="button" class="ci-stepper__btn ci-stepper__btn--minus" data-action="decrease" data-variant-id="${item.variant.id}">
                  <svg width="10" height="2" viewBox="0 0 10 2" fill="none"><rect width="10" height="2" rx="1" fill="currentColor"/></svg>
                </button>
                <input type="number" class="ci-stepper__input" value="${item.quantity}" min="1" data-variant-id="${item.variant.id}">
                <button type="button" class="ci-stepper__btn ci-stepper__btn--plus" data-action="increase" data-variant-id="${item.variant.id}">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><rect x="4" width="2" height="10" rx="1" fill="currentColor"/><rect y="4" width="10" height="2" rx="1" fill="currentColor"/></svg>
                </button>
              </div>
              <button type="button" class="ci-remove" data-variant-id="${item.variant.id}">Remove</button>
            </div>
          </div>
        `;
      }).join('');

      totalEl.innerHTML = formatPriceWithVAT(totalPrice);

      attachHandlers();

      // Apply VAT
      if (window.vatCheckForNewPrices) {
        setTimeout(() => window.vatCheckForNewPrices('quote page'), 100);
      }
    } catch (error) {
      console.error('Error loading quote items:', error);
      itemsContainer.innerHTML = '<p style="text-align:center;color:#e74c3c;padding:40px">Error loading items. Please try again.</p>';
    }
  }

  function attachHandlers() {
    document.querySelectorAll('.ci-stepper__btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const action = this.dataset.action;
        const input = document.querySelector(`.ci-stepper__input[data-variant-id="${variantId}"]`);
        const currentQty = parseInt(input.value) || 1;
        const newQty = Math.max(1, action === 'increase' ? currentQty + 1 : currentQty - 1);
        window.quoteBasket.updateQuantity(variantId, newQty);
        loadQuoteItems();
      });
    });

    document.querySelectorAll('.ci-stepper__input').forEach(input => {
      input.addEventListener('change', function() {
        const variantId = this.dataset.variantId;
        const qty = Math.max(1, parseInt(this.value) || 1);
        window.quoteBasket.updateQuantity(variantId, qty);
        loadQuoteItems();
      });
    });

    document.querySelectorAll('.ci-remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        if (confirm('Remove this item?')) {
          window.quoteBasket.removeItem(variantId);
          loadQuoteItems();
        }
      });
    });
  }

  if (whatsappBtn) {
    whatsappBtn.addEventListener('click', function() {
      const name = document.getElementById('quote-name').value.trim();
      const email = document.getElementById('quote-email-input').value.trim();
      const phone = document.getElementById('quote-phone').value.trim();
      const company = document.getElementById('quote-company').value.trim();
      const message = document.getElementById('quote-message').value.trim();

      if (!name || !email) {
        alert('Please fill in Name and Email');
        return;
      }

      const items = document.querySelectorAll('.quote-cart-item');
      if (items.length === 0) {
        alert('Your quote is empty');
        return;
      }

      let msg = '*QUOTE REQUEST*\n\n';
      msg += `Customer: ${name}\n`;
      msg += `Email: ${email}\n`;
      if (phone) msg += `Phone: ${phone}\n`;
      if (company) msg += `Company: ${company}\n`;
      msg += '\n*ITEMS:*\n';

      items.forEach((item, i) => {
        const title = item.querySelector('.ci-name a').textContent;
        const variant = item.querySelector('.ci-variant')?.textContent || '';
        const qty = item.querySelector('.ci-stepper__input').value;
        const price = item.querySelector('.ci-line-total').textContent;
        msg += `\n${i + 1}. ${title}`;
        if (variant) msg += ` - ${variant}`;
        msg += `\n   Qty: ${qty} | Price: ${price}\n`;
      });

      const total = totalEl.textContent.trim() || totalEl.innerText.trim();
      msg += `\n*TOTAL: ${total}*\n`;
      if (message) msg += `\nAdditional notes:\n${message}`;

      const url = `https://api.whatsapp.com/send/?phone=353873591457&text=${encodeURIComponent(msg)}`;
      window.open(url, '_blank');
    });
  }

  if (emailBtn) {
    emailBtn.addEventListener('click', function() {
      const name = document.getElementById('quote-name').value.trim();
      const email = document.getElementById('quote-email-input').value.trim();
      const phone = document.getElementById('quote-phone').value.trim();
      const company = document.getElementById('quote-company').value.trim();
      const message = document.getElementById('quote-message').value.trim();

      if (!name || !email) {
        alert('Please fill in Name and Email');
        return;
      }

      const items = document.querySelectorAll('.quote-cart-item');
      if (items.length === 0) {
        alert('Your quote is empty');
        return;
      }

      let body = `QUOTE REQUEST\n\n`;
      body += `Customer: ${name}\n`;
      body += `Email: ${email}\n`;
      if (phone) body += `Phone: ${phone}\n`;
      if (company) body += `Company: ${company}\n`;
      body += '\nITEMS:\n';

      items.forEach((item, i) => {
        const title = item.querySelector('.ci-name a').textContent;
        const variant = item.querySelector('.ci-variant')?.textContent || '';
        const qty = item.querySelector('.ci-stepper__input').value;
        const price = item.querySelector('.ci-line-total').textContent;
        body += `\n${i + 1}. ${title}`;
        if (variant) body += ` - ${variant}`;
        body += `\n   Qty: ${qty} | Price: ${price}\n`;
      });

      const total = totalEl.textContent.trim() || totalEl.innerText.trim();
      body += `\nTOTAL: ${total}\n`;
      if (message) body += `\nAdditional notes:\n${message}`;

      const mailtoUrl = `mailto:info@millenniummachinery.ie?subject=Quote Request from ${encodeURIComponent(name)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoUrl;
    });
  }

  // Load on page ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadQuoteItems);
  } else {
    loadQuoteItems();
  }
})();
